<template>
  <div
    v-if="data"
    class="banner"
    :style="{
      backgroundImage: `url(\'${$options.filters.image_by_id(data.img, $store.state)}\')`,
    }"
  >
    <div class="banner__content">
      <span class="banner__title">{{ data.title }}</span>
      <span class="banner__subtitle">{{ data.subtitle }}</span>
      <a :href="data.link" class="btn btn--main btn--md btn--with-icon">
        <span>Подробнее</span>
        <IconComponent name="arrow-right-1" />
      </a>
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "BannerComponent",
  components: { IconComponent },
  props: {
    data: Object,
  },
};
</script>

<style lang="stylus">
.banner {
  display flex
  justify-content center
  width 100%
  background-repeat no-repeat
  background-position center
  background-size cover
  background-color var(--gray)
  padding 60px 30px 55px
  +below(860px) {
    padding 37px 30px
  }
  +below(480px) {
    padding 30px
  }

  &__content {
    width 100%
    max-width 1000px
    display flex
    flex-direction column
    align-items flex-start
    gap 10px
    color: var(--main-color)
  }

  &__title {
    font-weight: 700;
    font-size: 2.125em
    line-height: 115%
    +below(840px) {
      font-size: 1.375em
    }
    +below(480px) {
      font-size: 1.125em
    }
  }

  &__subtitle {
    +below(840px) {
      font-size: 0.875em
    }
  }
}
</style>
